//로그인, 회원가입, 회원탈퇴
import { instance, authInstance } from '@/api/index';
/**
 * 회원가입 API
 * @param {*} v
 * @returns
 */
function registerUser(v) {
  //const url = 'http://localhost:3000/signup';
  //return axios.post(url, userData);
  return instance.post('signup', v);
}

/**
 * 로그인 API
 * @param {} v
 * @returns
 */
function certificate(tsId) {
  return authInstance.post('api/v1/' + tsId + '/certificate');
}

function logoutUser(tsId) {
  return authInstance.get('api/v1/' + tsId + '/logout');
}

export { registerUser, certificate, logoutUser };
